/**
 * Feature Flags
 * Control feature visibility based on environment variables
 */

export interface FeatureFlags {
  vendorDashboard: boolean;
  menuManagement: boolean;
  chatEnabled: boolean;
  earningsEnabled: boolean;
  alertsEnabled: boolean;
  offlineMode: boolean;
}

function parseFlag(value: string | undefined): boolean {
  if (!value) return false;
  return value.toLowerCase() === 'on' || value.toLowerCase() === 'true' || value === '1';
}

export const featureFlags: FeatureFlags = {
  vendorDashboard: parseFlag(import.meta.env.VITE_FEATURE_VENDOR_DASHBOARD),
  menuManagement: parseFlag(import.meta.env.VITE_FEATURE_MENU_MANAGEMENT),
  chatEnabled: parseFlag(import.meta.env.VITE_FEATURE_CHAT),
  earningsEnabled: parseFlag(import.meta.env.VITE_FEATURE_EARNINGS),
  alertsEnabled: parseFlag(import.meta.env.VITE_FEATURE_ALERTS),
  offlineMode: parseFlag(import.meta.env.VITE_FEATURE_OFFLINE),
};

export function isFeatureEnabled(feature: keyof FeatureFlags): boolean {
  return featureFlags[feature];
}


















